import api from "../../Hooks/axiosApi";

export const createLeadSourceService = (data: any) => {
    return api.post('/api/CrmLeads/AddLeadSource', data);
};

export const updateLeadSourceService = ({ sourceID, data }: { sourceID: any; data: any }) => {
    return api.put(`/api/CrmLeads/UpdateLeadSource`, data);
};

export const deleteLeadSourceService = (id: any) => {
    return api.delete(`/api/CrmLeads/SoftDeleteLeadSource/${id}`);
};

export const getAllLeadSourcesService = () => {
    return api.get('/api/CrmLeads/GetAllLeadSources');
};

export const getLeadSourceByIdService = (id: any) => {
    return api.get(`/api/CrmLeads/GetLeadSourceById/${id}`);
};
